import React from 'react';
import TurnOff from '../TurnOff/TurnOff';

const Seller = ({endDate, openPopup, turnOff, userId, isMobile}) => (
    <div className="content seller-view">
        <h3 className="title" dangerouslySetInnerHTML={{ __html: i18n.t('out_of_office.banner.seller.you_are_out_until', {endDate}) }}></h3>
        {!isMobile && <p className="notice">
            <a className="popup-link" onClick={(e) => openPopup(e, 'gigs_page')}>
                <i className="fa fa-pencil" aria-hidden="true"></i> {i18n.t('out_of_office.general.edit')}
            </a>
            <TurnOff turnOff={turnOff} userId={userId}/>
        </p>}
    </div>
);

export default Seller;


// WEBPACK FOOTER //
// ./src/GigBanner/Seller.js